import { createAsyncThunk } from "@reduxjs/toolkit";
import 'react-toastify/dist/ReactToastify.css';

import {
  getCategories,
  getCategoryList,
  searchCategories as searchCategoriesFN,
  getCategoriesSelect as selectFinalCategory,
  
} from "../../helpers/backend_helper";
import { getCategorySearchAi } from "helpers/backend_helper_ai";
// import { getCategorySearchAi } from "helpers/backend_helper_ai";

export const getCategoriesFunc = createAsyncThunk("category/getAllCategories", async (id: any = '') => {
  try {
    const response = await getCategories(id);
    return response.data;

  } catch (error) {
    return [];
  }
});

export const getCategoriesSelectFunc = createAsyncThunk("category/getCategoriesSelectFunc", async (categoryId: string) => {
  try {
    const response = await selectFinalCategory(categoryId);
    return response.data;

  } catch (error) {
    return [];
  }
});

export const searchCategoriesFunc = createAsyncThunk("category/searchCategoriesFunc", async (keyword: string) => {
  try {
    const response = await searchCategoriesFN(keyword);
    return response.data;
  } catch (error) {
    return [];
  }
});


export const getCategoriesByNameAI = createAsyncThunk("category/getCategoriesByNameAI", async (keyword: string) => {
  try {
    const response = await getCategorySearchAi(keyword);
    return response;
  } catch (error) {
    return [];
  }
});

export const clearCategoriesByNameAI = createAsyncThunk("category/clearCategoriesByNameAI", async () => {
 
    return [];
  
});
export const clearSearchCategoriesFunc = createAsyncThunk("category/clearSearchCategoriesFunc", () => {
  return [];
});

export const appendCategoryList = createAsyncThunk("category/appendCategoryList", async (data: any) => {
  return data;
});


export const getCategoryThunk = createAsyncThunk(
  "category/categoryList", async({page,count, keyword} : {keyword: string,page:number, count: number}) => {
    try {
      const response = await getCategoryList(page, count,keyword);
      return response.data
    } catch (error) {
      return error;
    }
  });
